import { BANK_CONNECTION_PROVIDER } from "constants/dataSource";
import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";
import { BankConnection, Banks } from "types/Models/banks";

export const bankName = (nickName: string, mask: string) => {
  if (!mask) {
    return nickName;
  }
  return `${nickName} \u2022\u2022${mask}`;
};

export const getDisconnectedMessage = (connection: BankConnection) => {
  if (!connection.last_disconnected_at) return "Disconnected";
  return `Disconnected since ${dayjs(connection.last_disconnected_at).format(
    DISPLAY_DATE
  )}`;
};

export const isStripeBank = (bank?: Pick<Banks, "bank_brand"> | null) =>
  bank?.bank_brand?.connection_provider === BANK_CONNECTION_PROVIDER.STRIPE;
